import { mapActions, mapGetters } from 'vuex';
import rolePermission from '@js/store/modules/role-permission';
import userModule from '@js/store/modules/user';

export default {
    computed: {
        ...mapGetters('outlet', ['allowedOutletList']),
        ...mapGetters('rolePermission', ['roleList']),
        ...mapGetters('user', ['user', 'userExists', 'userIsSuperAdmin']),

        userOutletList: {
            get() {
                return this.user.outlets;
            },
            set(outlets) {
                this.setUserAttr({ key: 'outlets', value: outlets });
            },
        },

        userRoleList: {
            get() {
                return this.user.roles;
            },
            set(roles) {
                this.setUserAttr({ key: 'roles', value: roles });
            },
        },

        roles() {
            if (!this.isSuperAdmin()) {
                return this.roleList.filter(r => r.name != this.superAdminRole);
            }

            return this.roleList;
        },

        passwordRule() {
            if (this.user.id === null) return 'required|min:6';
            return 'min:6';
        },

        canUpdate() {
            if (
                this.userExists &&
                this.userIsSuperAdmin &&
                !this.isSuperAdmin()
            ) {
                return false;
            }

            return this.can(this.permission.SAVE_USER);
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('rolePermission')) {
            this.$store.registerModule('rolePermission', rolePermission);
        }

        if (!this.$store.hasModule('user')) {
            this.$store.registerModule('user', userModule);
        }
    },

    created() {
        if (!this.allowedOutletList.length) {
            this.getOutletList();
        }

        if (!this.roleList.length) {
            this.getRoleList();
        }
    },

    methods: {
        ...mapActions('outlet', ['getOutletList']),
        ...mapActions('rolePermission', ['getRoleList']),
        ...mapActions('user', [
            'createUser',
            'updateUser',
            'setUserAttr',
            'fetchUser',
        ]),
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/user/user-mixin.js